// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"31ae1e27","230":"e7a92e25","271":"653b6288","466":"f441ba24","488":"f430e37a","566":"d11ac87b","589":"ff1edd0d","657":"7bbe5492","684":"67bd19d9","722":"c8bb560f","726":"fc81cf84","767":"0f7045d4","811":"f93933ad","908":"5600f72c"}[chunkId] + ".chunk.js";
};